// ----------------------------------------------------------------------------
// Snippet: Power Tools Filter
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';


//Power Tools Filter popup on mobile
$('body, html').on('click', '.filter-menu__popup__close', function(e){
    e.preventDefault();
    $('.filter-menu__popup').removeClass('active');
    $('body').removeClass('fixedHeight');
})

$('body, html').on('click', '.filter-menu__popup__trigger', function(e){
    e.preventDefault();
    $('.filter-menu__popup').addClass('active');
    $('body').addClass('fixedHeight');
})